import { $ } from '../../../zeus'
import { typedGql } from '../../../zeus/typedDocumentNode'

export const UPDATE_WEBHOOK = typedGql('mutation')({
  updateWebhook: [
    {
      input: $('input', 'WebhookUpdateInput!'),
    },
    {
      id: true,
      name: true,
      isRedboxApi: true,
      forJobStatus: true,
      url: true,
    },
  ],
})
